export default "__VITE_ASSET__BUa5akW6__"